import React, { useState } from 'react'
import Swal from 'sweetalert2';
import { delete_user_clover_saved_card_API } from '../../../../../Studio-Services/Studio_Services';
import { errorAlert } from '../../../../../Static_Services/Alertmsg';
import AddCardModalNew from '../AddCardModalNew';
import { AiFillPlusCircle } from "react-icons/ai";

export default function CustomerCloverCards({ setLoader, cloverCards, getCustomerCloverCard, getProfile, child_ID, user_id, studioData }) {
    const [showCardModal, setShowCardModal] = useState(false);

    const deleteCardDetailHandler = (data) => {
        const profileID = data?.customer_code || '';
        const cardID = data?.card_id || '';
        if (!profileID) { errorAlert("Clover profile id is required"); return; }
        if (!cardID) { errorAlert("Clover card id is required"); return; }

        const payload = {
            'profile_id': profileID,
            'card_id': cardID
        };
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoader(true);
                try {
                    const resp = await delete_user_clover_saved_card_API(payload);
                    Swal.fire({
                        title: resp.data.status == 1 ? "Success!" : "Error!",
                        text: resp.data.message,
                        icon: resp.data.status == 1 ? "success" : "error"
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            getCustomerCloverCard();
                            getProfile();
                        }
                    })

                } catch (error) {
                    console.log("@error", error);
                    Swal.fire({
                        title: "Error!",
                        text: "Something went wrong",
                        icon: "error"
                    });
                } finally { setLoader(false); }
            }
        });
    };

    return (
        <>
            < div class="client-payment-input border-radius6 box-shadow1  mt-4" style={{ background: "#f2f3f5" }
            }>
                <div className='col-12 pt-4 d-flex' style={{ justifyContent: 'space-between' }}>
                    <h4 className="title text-capitalize pl-0">Saved Card</h4>
                    <button class="btn btn-success flex-fill d-flex"
                        onClick={() => { setShowCardModal(true) }}
                        style={{ maxWidth: '4%', background: '#02793f' }}>
                        <AiFillPlusCircle size={30} />
                    </button>
                </div>
                {
                    cloverCards && cloverCards.length != 0 &&
                    <div class="row p-4" >
                        {(cloverCards || []).map((cardsave) => (
                            <div class="col-md-6 mb-3" >
                                <div class="payment-history-box white-bg border-radius6 box-shadow1 p-3 mb-3">
                                    <div class="row mx-0">


                                        <div class="col-2 pl-0">
                                            {(cardsave.card_type == 'VISA' || cardsave?.card_type == 'visa') &&
                                                <img src="clientassets/img/visa_card.png" class="img-fluid" />}
                                            {cardsave.card_type == 'MC' &&
                                                <img src="clientassets/img/master_card.png" class="img-fluid" />}
                                            {cardsave.card_type == 'AM' &&
                                                <img src="clientassets/img/american_express.png" class="img-fluid" />}
                                        </div>
                                        <div class="col-8 pl-0">
                                            <p class="mb-0 font-14 font-w-500 dark-color">{cardsave?.name}</p>

                                            <p class="mb-0 font-14 font-w-500 dark-color">{cardsave.number}</p>
                                            <h5 class="mb-0 font-12 dark-color mt-2">Valid Till(MM/YYYY) </h5>
                                            <p class="mb-0 font-12 dark-color">{cardsave.expiry_month} / {cardsave.expiry_year}</p>
                                        </div>
                                        <div class="col-2 text-right">
                                            <button class="btn btn-danger flex-fill ml-2"
                                                onClick={() => deleteCardDetailHandler(cardsave)}
                                            >
                                                <i class="fas fa-trash-alt"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                }
                {
                    cloverCards.length == 0 &&
                    <div class="row">
                        <p class="text-center">No Record Found</p>
                    </div>
                }

            </div >
            {/* Add Card Modal */}
            < AddCardModalNew
                showCardModal={showCardModal}
                setShowCardModal={setShowCardModal}
                clientIDS={user_id}
                child_ID={child_ID}
                studioData={studioData}
                setLoder={setLoader}
                getCustomerCloverCard={getCustomerCloverCard}
            />

        </>
    )
}
